module.exports = __webpack_public_path__ + "img/u1194.caaeea81.svg";